<script>
import { defineComponent, h } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import WhatsappCall from './channels/WhatsappCall.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';
import ProviderWhatsapp from './channels/ProviderWhatsapp.vue';
import NotificameChannel from './channels/NotificameChannel.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  whatsapp_call: WhatsappCall,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  voice: Voice,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  render() {
    // NotificaMe é provedor VIRTUAL (chave "provider_notificame"): conexão própria,
    // sem QR. Tratado antes do genérico, que faria Number('notificame') => NaN.
    if (this.channelName === 'provider_notificame') {
      return h(NotificameChannel);
    }
    // canais de provedor WhatsApp não-oficial: chave "provider_<id>"
    if (this.channelName?.startsWith('provider_')) {
      const providerId = Number(this.channelName.replace('provider_', ''));
      return h(ProviderWhatsapp, { providerId });
    }
    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
